import { ColumnsType } from 'antd/lib/table'
import RewindQueueEntry from '../../../../types/api/rewind-queue-entry'
import ShipmentPosition from '../../../../types/api/shipment-position'
import { MaterialColumnCell } from '../../../schedules/flexo/components/cells/material-column-cell'
import PrintEndTimeCell from '../../../schedules/rewind/components/cells/print-end-time-cell'
import RewindCopiesCell from '../../../schedules/rewind/components/cells/rewind-copies-cell'
import RewindJobNumberCell from '../../../schedules/rewind/components/cells/rewind-job-number-cell'
import { getShipmentFloods } from '../../../schedules/rewind/helpers/get-shipment-floods'
import ActionsCell from './components/actions-cell'

export const columns: ColumnsType<RewindQueueEntry> = [
    {
        dataIndex: ['rewind_job', 'id'],
        title: 'Номер перемотки',
        width: 70,
        render: (_value, record) => <RewindJobNumberCell rewindJob={record.rewind_job} />,
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'print_job', 'id'],
        title: 'Номер печати',
        width: 95,
        render: (_value, record) => record.rewind_job?.shipment?.print_job?.id || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'id'],
        title: 'Номер отгрузки',
        width: 95,
        render: (_value, record) => record.rewind_job?.shipment?.id || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'client', 'name'],
        title: 'Заказчик',
        render: (_value, record) => record.rewind_job?.shipment?.client?.name || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'materialRequirements'],
        title: 'Материал',
        width: 110,
        render: (_value, record) => (
            <MaterialColumnCell value={record.rewind_job?.shipment?.materialRequirements || []} />
        ),
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'bushing'],
        title: 'Втулка',
        width: 70,
        render: (_value, record) => record.rewind_job?.shipment?.bushing || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'shipment_positions'],
        title: 'Ручьи',
        width: 70,
        render: (_value: ShipmentPosition[], record) => {
            const floods = getShipmentFloods(record.rewind_job?.shipment)

            return floods ?? '—'
        },
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'stamp', 'number'],
        title: 'Штамп',
        width: 100,
        render: (_value, record) => {
            const stamp = record.rewind_job?.shipment?.stamp

            return stamp?.number || '—'
        },
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'shipment_positions'],
        title: 'Тираж',
        width: 90,
        render: (_value, record) => <RewindCopiesCell rewindJob={record.rewind_job} />,
    },
    {
        key: 'printEndAt',
        title: 'Время окончания печати',
        width: 90,
        render: (_value, record) => <PrintEndTimeCell shipment={record.rewind_job?.shipment} />,
    },
    {
        dataIndex: 'actions',
        title: '',
        fixed: 'right',
        width: 400,
        render: (_value, record) => <ActionsCell rewindQueueEntry={record} />,
    },
]
